module.exports = __webpack_public_path__ + "static/img/banner.b831cddb.png";